import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IItpListQueryPaginationPayload } from '@app-store/slices/companies/itpList'

interface TaskAction extends Action {
    payload: IItpListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.itpList

function* itpListSagaTask({ payload }: TaskAction) {
    try {
        const params = yield getParams(payload)

        const response = yield axios.get(`/companies/itps`, {
            params
        })

        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result.data)
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* itpListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, itpListSagaTask)
}

export default itpListSaga
